import { batch } from '@preact/signals-core';
import { applyUpdate, type Doc } from 'yjs';

export interface DatabaseLivePublicationMember {
  readonly doc: Doc;
  readonly update: Uint8Array;
  readonly origin: unknown;
  /** The root or a directory part: the directory, applied before row shards. */
  readonly directory?: boolean;
}

/** A durable publication may span multiple Y.Docs. Publish its UI projection
 * in one synchronous signal batch: observers must never see half a manifest
 * or a root whose row documents still describe the previous receipt.
 * The directory (root head and parts, whose open last part counts the rows)
 * lands first and `directoryApplied` announces it, so a consumer reading on a
 * row shard's update already sees the new row count.
 * Resolve documents and await storage before entering this boundary. */
export function applyDatabaseLivePublication(
  members: readonly DatabaseLivePublicationMember[],
  refresh: () => void,
  directoryApplied?: () => void
): void {
  batch(() => {
    const directory = members.filter(member => member.directory);
    for (const member of directory)
      applyUpdate(member.doc, member.update, member.origin);
    if (directory.length) directoryApplied?.();
    for (const member of members)
      if (!member.directory)
        applyUpdate(member.doc, member.update, member.origin);
    refresh();
  });
}
